import { PartialLogBody, reportLog } from './clientLogger'
import { ClientLogSeverity } from './ClientLogBody'
import { TrackJS } from 'trackjs'
import { isEmpty, isNil } from '@/helpers/helpers'

export const createLogBodyFromError = (
  error: Error,
  additionalMessage?: string,
  severity: ClientLogSeverity = 'error'
): PartialLogBody => {
  let message = error?.message ?? `uncaught error occurred - error object: ${JSON.stringify(error)}`
  message = !isEmpty(additionalMessage) ? `${message} ${additionalMessage}` : message

  return {
    severity,
    stack_trace: error?.stack,
    message
  }
}

export const captureMainErrors = (): void => {
  window.addEventListener('error', (event: ErrorEvent) => {
    const eventMessage = !isNil(event?.message) ? ` Event: ${event.message}` : ''
    const trackJSError = event?.error || `Uncaught Error.${eventMessage}`

    const log = createLogBodyFromError(event?.error, eventMessage)
    reportLog(log)
    if (log.severity === 'error') {
      TrackJS?.isInstalled() && TrackJS.track(trackJSError)
    }
  })
}

export const captureUnhandledRejections = (): void => {
  window.addEventListener('unhandledrejection', (event) => {
    const message =
      event?.reason?.message ??
      `unhandledrejection - reason: ${!isNil(event?.reason) ? JSON.stringify(event.reason) : JSON.stringify(event)}`
    const stack: string = event?.reason?.stack
    const severity: ClientLogSeverity = !isNil(event?.reason) ? 'error' : 'warn'
    reportLog({
      message,
      severity,
      stack_trace:
        stack
          ?.split('\n')
          .filter((line) => line.trim().startsWith('at '))
          .join('\n') ?? ''
    })
    TrackJS?.isInstalled() && TrackJS.track(event?.reason)
  })
}

export const captureWindowErrors = (): void => {
  captureMainErrors()
  captureUnhandledRejections()
}
